import React from 'react';
import { connect } from 'react-redux';

import { Select } from 'redpoints-front-components/index';

import { allIncidentsFiltersSetAsset } from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsAssetsResponse,
  getAllIncidentsFiltersAssetSelected,
} from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersAsset = ({
  allIncidentsFiltersSetAsset,
  assetsDataResponse,
  assetSelected,
}) => {
  const handlerSetAsset = assetId => allIncidentsFiltersSetAsset({ assetId });

  return (
    <Select
      allowClear
      data={assetsDataResponse}
      label={translate('reporting.allIncidentsInternal.filters.asset')}
      mapping={{ key: 'assetId', value: 'name' }}
      onChange={handlerSetAsset}
      placeholder={translate('common.all')}
      value={assetSelected || undefined}
      showSearch
    />
  );
};

const mapStateToProps = (state, reportType) => ({
  assetsDataResponse: getAllIncidentsAssetsResponse(state, reportType),
  assetSelected: getAllIncidentsFiltersAssetSelected(state),
});

export default connect(mapStateToProps, {
  allIncidentsFiltersSetAsset,
})(AllIncidentsFiltersAsset);
